import React from "react";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { FlowEditContext } from "../../FlowEditContext";
import { FlowConfiguration } from "../../../rule-engine-core/Flow/FlowConfiguration";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

export const EditLayer = function (props: { flow: FlowConfiguration; editContext: FlowEditContext }) {
    return (
        <ObserveState
            listenTo={props.editContext}
            properties={[FlowEditContext.SELECTION_ELEMENT]}
            control={() => {
                let selectedStep = props.editContext.selectionElement;
                let title: string = "Edit";

                if (selectedStep) {
                    title = "Edit (Step)";
                    if (selectedStep instanceof FlowStepSequence) title = "Edit (Sequence)";
                    if (selectedStep instanceof FlowConfiguration) title = "Edit (Flow Settings)";

                    let name = Reflect.get(selectedStep, "name");
                    if (name) {
                        title = title + ": " + name;
                    }
                }

                let editUIComponent = props.editContext.renderEditUI(props.editContext, selectedStep);
                return (
                    <>
                        {editUIComponent && (
                            <UISpacedBoxContent padding={"10px"}>
                                <UILabel>{title}</UILabel>
                                <UISpacedBoxContent>{editUIComponent}</UISpacedBoxContent>
                            </UISpacedBoxContent>
                        )}
                    </>
                );
            }}
        />
    );
};
